import icFileUp from 'assets/images/ic-file-up-02.svg'
import { ExportModal } from 'components/commons/ExportModal'
import Button from 'components/commons/button'
import Search from 'components/commons/search'
import Table from 'components/commons/table'
import Toast from 'components/commons/toast'
import ViewList from 'components/commons/view-list'
import { LeaveAnalyticsFilterContainer } from 'containers/leave-management/leave-analytics/LeaveAnalyticsFilterContainer'

export const LeaveAnalytics = ({
    dataAnalyticsLeave,
    configTable,
    isLoading,
    query,
    selectedItems,
    modal,
    queryFilter,
    toastMessage,
    onChangeQuery,
    setSelectedItems,
    onExport,
    onSetModal,
}) => {
    return (
        <div className='flex flex-col'>
            <div className={'flex flex-row gap-3 px-6 py-4'}>
                <Search value={query?.search} onSearch={(search) => onChangeQuery({ page: 1, search })} />
                <ViewList
                    show={modal?.limit}
                    onShow={() => onSetModal({ limit: true })}
                    onClose={() => onSetModal({ limit: false })}
                    value={query?.limit}
                    onSelectSize={(limit) => onChangeQuery({ page: 1, limit })}
                />
                <LeaveAnalyticsFilterContainer
                    queryFilter={queryFilter}
                    onSubmit={(queryFilter) => onChangeQuery({ ...queryFilter, page: 1 })}
                />
                <Button
                    title='Export'
                    icon={icFileUp}
                    type='outline'
                    disabled={!dataAnalyticsLeave?.total_result}
                    onClick={() => onSetModal({ export: true })}
                />
            </div>

            <Table
                className='my-3'
                name={configTable.name}
                data={dataAnalyticsLeave?.results}
                columns={configTable.column}
                size={dataAnalyticsLeave?.limit}
                totalPage={dataAnalyticsLeave?.total_page}
                totalResult={dataAnalyticsLeave?.total_result}
                currentPage={query.page}
                onChangePage={(page) => onChangeQuery({ page })}
                onSelectItem={setSelectedItems}
                onClickSort={(sortQuery) => onChangeQuery({ ...sortQuery, page: 1 })}
                loading={isLoading}
            />

            <ExportModal
                title='Apakah anda yakin ingin melakukan export data?'
                description={`Total data list analytics leave: ${selectedItems?.length || dataAnalyticsLeave?.total_result || 0}`}
                show={modal?.export}
                onExportHandler={onExport}
                onCancelHandler={() => onSetModal({ export: false })}
            />
            <Toast show={modal?.toast} message={toastMessage} onClose={() => onSetModal({ toast: false })} />
        </div>
    )
}
